import { render, staticRenderFns } from "./dangerousGoodsModal.vue?vue&type=template&id=9d9af8dc&"
import script from "./dangerousGoodsModal.vue?vue&type=script&lang=js&"
export * from "./dangerousGoodsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports